import { newModalFromString } from './modal';

let modal;
let html = $('#green-choice').html();

$('body').on('click', '.eco-green.icon', function(e){
    if($('body').width() < 769) {
        e.preventDefault();
        e.stopPropagation();
        modal = newModalFromString(html, false, ['green-choice']);
        modal.open();
    }
}).on('click', '.green-choice .close', function(){
    modal.close();
});